/**
 * Telematics alerts API client.
 *
 * Backed by /telematics/alerts in os-core. Wialon poller writes;
 * we read + ack.
 */

import { api, type RequestOptions } from "./client";


export type AlertRuleType =
  | "geofence_exit"
  | "idle_too_long"
  | "fuel_drop"
  | "speed_over";


export interface TelematicsAlertDto {
  id:               string;
  rule_id:          string;
  rule_type:        AlertRuleType;
  vehicle_id:       string;
  occurred_at:      string;
  details:          Record<string, unknown>;
  acknowledged_at:  string | null;
  acknowledged_by:  string | null;
}


export type AcknowledgedFilter = "false" | "true" | "all";


export const telematicsApi = {
  listAlerts(
    opts?: RequestOptions & {
      acknowledged?: AcknowledgedFilter;
      ruleType?:     AlertRuleType;
      vehicleId?:    string;
      limit?:        number;
    },
  ): Promise<TelematicsAlertDto[]> {
    const p = new URLSearchParams();
    if (opts?.acknowledged) p.set("acknowledged", opts.acknowledged);
    if (opts?.ruleType)     p.set("rule_type",    opts.ruleType);
    if (opts?.vehicleId)    p.set("vehicle_id",   opts.vehicleId);
    if (opts?.limit)        p.set("limit",        String(opts.limit));
    const q = p.toString();
    return api.get<TelematicsAlertDto[]>(
      `/telematics/alerts${q ? `?${q}` : ""}`, opts,
    );
  },

  /** Mark an alert as handled. Idempotent — calling twice
   *  returns the same row, original timestamp preserved. */
  ackAlert(
    alertId: string, opts?: RequestOptions,
  ): Promise<TelematicsAlertDto> {
    return api.patch<TelematicsAlertDto>(
      `/telematics/alerts/${alertId}/ack`, {}, opts,
    );
  },
};
